import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
  import { computed, ref } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import store from "@/store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerProfileView',
  setup(__props, { expose: __expose }) {
  __expose();

  const user = computed(() => store.state.user.data);
  const isDeleteAccountModal = ref(false);
  const isErrorOnDelete = ref(false);

  function onCancel() {
    isDeleteAccountModal.value = false;
    isErrorOnDelete.value = false;
  }
  function onEdit() {
    router.push({ name: "CustomerProfileEditView" });
  }
  function onChangePassword() {
    router.push({ name: "CustomerProfileChangePasswordView" });
  }
  function onDelete() {
    isDeleteAccountModal.value = true;
  }
  function onProceed() {
    onCancel();
    router.push({ name: "CustomerLots" });
  }
  function deleteAccount() {
    store
      .dispatch("user/deleteUser", user.value._id)
      .then(() => {
        onCancel();
        router.push("/");
      })
      .catch((error) => {
        if (error.response.data.statusCode === 409) {
          isErrorOnDelete.value = true;
        }
      });
  }

const __returned__ = { user, isDeleteAccountModal, isErrorOnDelete, onCancel, onEdit, onChangePassword, onDelete, onProceed, deleteAccount, get router() { return router }, computed, ref, Modal, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})